module.exports = __webpack_public_path__ + "img/SCB.e7187097.svg";